import { Location } from 'types';
import { FilterOperator, FilterState, LogicalOperator, filtersToRsqlString } from 'utils';
import fetchWithRetry from './fetch-retry';

export const getLocations = async (): Promise<Location[]> =>
  await fetchWithRetry<Location[]>('/api/locations', { method: 'GET' }, []);

export const getAllLocations = async (): Promise<Location[]> =>
  await fetchWithRetry<Location[]>('/api/trucking-companies/locations', { method: 'GET' }, []);

export const searchLocations = async (input: string, filterByUserAssociations = true): Promise<Location[]> => {
  const url = new URL('/api/locations/search', window.location.origin);

  const filter: FilterState = {
    logicalOperator: LogicalOperator.AND,
    filters: input
      .split(/[^a-zA-Z0-9]/)
      .map(value => ({ field: 'name', value, filterOperator: FilterOperator.CONTAINS }))
  };

  url.searchParams.append('filterByUserAssociations', filterByUserAssociations.toString());
  url.searchParams.append('filterString', filtersToRsqlString(filter));

  return await fetchWithRetry<Location[]>(url, { method: 'GET' }, []);
};